import PropTypes from 'prop-types'
import { QuizType } from './M047Constants'

export const M047PropTypes = {
  type: PropTypes.oneOf(['M047']),
  elements: PropTypes.arrayOf(
    PropTypes.oneOfType([
      // Introduction
      PropTypes.shape({
        type: PropTypes.oneOf(['introduction']),
        headline: PropTypes.shape({
          tag: PropTypes.string,
          text: PropTypes.string,
          placeholder: PropTypes.shape({
            text: PropTypes.string,
          }),
        }),
        text: PropTypes.string,
        startButtonTitle: PropTypes.string,
      }),

      // Single Selection for Quiz Type "Selbsttest"
      PropTypes.shape({
        type: PropTypes.oneOf(['single-selection']),
        headline: PropTypes.shape({
          tag: PropTypes.string,
          text: PropTypes.string,
          placeholder: PropTypes.shape({
            text: PropTypes.string,
          }),
        }),
        image: PropTypes.shape({
          alt: PropTypes.string,
          variants: PropTypes.arrayOf(
            PropTypes.shape({
              url: PropTypes.string,
              breakpoint: PropTypes.number,
            })
          ),
        }),
        icon: PropTypes.string,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
            weight: PropTypes.number,
            image: PropTypes.shape({
              alt: PropTypes.string,
              variants: PropTypes.arrayOf(
                PropTypes.shape({
                  url: PropTypes.string,
                  breakpoint: PropTypes.number,
                })
              ),
            }),
          })
        ),
        settings: PropTypes.shape({
          imageType: PropTypes.oneOf(['picture', 'icon']),
          imagePerAnswer: PropTypes.bool,
          imageShape: PropTypes.oneOf(['circle', 'rectangle']),
        }),
      }),

      // Single Selection for Quiz Type "Wahr/Falsch"
      PropTypes.shape({
        type: PropTypes.oneOf(['single-selection']),
        headline: PropTypes.shape({
          tag: PropTypes.string,
          text: PropTypes.string,
          placeholder: PropTypes.shape({
            text: PropTypes.string,
          }),
        }),
        image: PropTypes.shape({
          alt: PropTypes.string,
          variants: PropTypes.arrayOf(
            PropTypes.shape({
              url: PropTypes.string,
              breakpoint: PropTypes.number,
            })
          ),
        }),
        icon: PropTypes.string,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
            weight: PropTypes.number,
            image: PropTypes.shape({
              alt: PropTypes.string,
              variants: PropTypes.arrayOf(
                PropTypes.shape({
                  url: PropTypes.string,
                  breakpoint: PropTypes.number,
                })
              ),
            }),
          })
        ),
        solutionText: PropTypes.string,
        settings: PropTypes.shape({
          imageType: PropTypes.oneOf(['picture', 'icon']),
          imagePerAnswer: PropTypes.bool,
          imageShape: PropTypes.oneOf(['circle', 'rectangle']),
        }),
      }),

      // Multi Selection
      PropTypes.shape({
        type: PropTypes.oneOf(['multi-selection']),
        headline: PropTypes.shape({
          tag: PropTypes.string,
          text: PropTypes.string,
          placeholder: PropTypes.shape({
            text: PropTypes.string,
          }),
        }),
        options: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
            weight: PropTypes.number,
            image: PropTypes.shape({
              alt: PropTypes.string,
              variants: PropTypes.arrayOf(
                PropTypes.shape({
                  url: PropTypes.string,
                  breakpoint: PropTypes.number,
                })
              ),
            }),
          })
        ),
        image: PropTypes.shape({
          alt: PropTypes.string,
          variants: PropTypes.arrayOf(
            PropTypes.shape({
              url: PropTypes.string,
              breakpoint: PropTypes.number,
            })
          ),
        }),
        icon: PropTypes.string,
        settings: PropTypes.shape({
          imageType: PropTypes.oneOf(['picture', 'icon']),
          imagePerAnswer: PropTypes.bool,
          imageShape: PropTypes.oneOf(['circle', 'rectangle']),
        }),
      }),

      // Multi Selection Chip
      PropTypes.shape({
        type: PropTypes.oneOf(['multi-selection-chip']),
        headline: PropTypes.shape({
          tag: PropTypes.string,
          text: PropTypes.string,
          placeholder: PropTypes.shape({
            text: PropTypes.string,
          }),
        }),
        subtitle: PropTypes.string,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
            weight: PropTypes.number,
          })
        ),
      }),

      // Range Slider Selection
      PropTypes.shape({
        type: PropTypes.oneOf(['range-slider-selection']),
        headline: PropTypes.shape({
          tag: PropTypes.string,
          text: PropTypes.string,
          placeholder: PropTypes.shape({
            text: PropTypes.string,
          }),
        }),
        subtitle: PropTypes.string,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
            weight: PropTypes.number,
          })
        ),
      }),

      // Summary
      PropTypes.shape({
        type: PropTypes.oneOf(['summary']),
        headline: PropTypes.shape({
          tag: PropTypes.string,
          text: PropTypes.string,
          placeholder: PropTypes.shape({
            text: PropTypes.string,
          }),
        }),
        text: PropTypes.string,
        summaryText: PropTypes.arrayOf(
          PropTypes.shape({
            headline: PropTypes.shape({
              tag: PropTypes.string,
              text: PropTypes.string,
              placeholder: PropTypes.shape({
                text: PropTypes.string,
              }),
            }),
            text: PropTypes.string,
            from: PropTypes.number,
            to: PropTypes.number,
          })
        ),
      }),
    ])
  ),
  settings: PropTypes.shape({
    quizType: PropTypes.oneOf(Object.values(QuizType)),
  }),
}
